import Icon from '../components/Icon.vue'

Icon.register({
  'chess-knight': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M352 224V448H32V401.4C32 371.1 49.1 343.4 76.2 329.9L133.5 301.3A48-48 0 0 1 160 258.3V208L137.9 219.1A24-24 0 0 1 125.3 234.7L113.5 282A12-12 0 0 0 106.3 290.3L76.7 302.1A12-12 0 0 0 67.4 301.9L7.1 275.2A12-12 0 0 0 0 264.2V105.9C0 99.6 2.5 93.5 7 89L16 80 1.8 51.6A16.9-16.9 0 0 0 0 44C0 37.4 5.4 32 12 32H160C266 32 352 118 352 224zM372 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H372C378.6 512 384 506.6 384 500V476C384 469.4 378.6 464 372 464zM52 128C41 128 32 137 32 148S41 168 52 168 72 159 72 148 63 128 52 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-knight.js
// module id = FtOo
// module chunks = 144